import { render, staticRenderFns } from "./AdminBoardView.vue?vue&type=template&id=cdd4640c&"
import script from "./AdminBoardView.vue?vue&type=script&lang=js&"
export * from "./AdminBoardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports